module.exports = __webpack_public_path__ + "static/OnCallogy.a16d9b6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/OnCallogy.png
// module id = ./src/media/OnCallogy.png
// module chunks = 11056403903869698000